import type { FC, ReactNode } from 'react'

import { Rule } from '@/components/generals/rule'
import { Reveal } from '@/components/generals/reveal'
import { Counter } from '@/components/generals/counter'
import { SectionLabel } from '@/components/generals/section-label'
import { studioNumbers } from '@/constants/studio'

export const StudioNumbers: FC = (): ReactNode => {
    return (
        <section
            id='studio-numbers'
            aria-label='By the numbers'
            className='relative z-10 bg-paper text-ink'
        >
            <div className='mx-auto flex max-w-[1920px] flex-col gap-8 px-5 sec-b lg:gap-12 lg:px-[33px]'>
                <SectionLabel label='by the numbers.' />

                <div className='grid grid-cols-1 gap-x-5 gap-y-10 sm:grid-cols-2 lg:grid-cols-4'>
                    {studioNumbers.map((entry, index) => (
                        <div key={entry.label} className='flex flex-col gap-6'>
                            <Rule delay={index * 0.07} />

                            <Reveal
                                from='up'
                                distance={30}
                                delay={index * 0.07}
                                className='flex flex-col gap-5'
                            >
                                <span className='t-mono text-ash'>
                                    {entry.label}
                                </span>

                                <h2
                                    className='t-display text-ink'
                                    style={{ fontSize: 'clamp(45px, 6vw, 80px)' }}
                                >
                                    <Counter value={entry.value} />
                                </h2>
                            </Reveal>
                        </div>
                    ))}
                </div>

                <Rule />
            </div>
        </section>
    )
}
